import type {
  FlightOffer,
  MappedFlightOffer,
} from "@/features/flights/types/types";

export const mapToFlightOffer = (
  selectedFlightsKeys: string[],
  offer: MappedFlightOffer,
): FlightOffer => {
  const flightOverview = offer.flightsOverview.find((fo) =>
    selectedFlightsKeys.every((fr) => fo.flightReferences.includes(fr)),
  );
  if (!flightOverview) throw new Error();

  const selectedFlights = [flightOverview.departureFlight];
  if (flightOverview.returnFlight) {
    selectedFlights.push(flightOverview.returnFlight);
  }

  return {
    index: offer.index,
    offerItems: offer.offerItems,
    itineraryIndex: flightOverview.itineraryIndex,
    totalPrice: offer.totalPrice,
    currency: offer.currency,
    searchResultKey: offer.searchResultKey,
    searchResultToken: offer.searchResultToken,
    upsellSupport: offer.upsellSupport,
    defaultFare: offer.upsellOption,
    flights: selectedFlights,
  };
};
